import React from "react";
import { Section } from "@atoms/Section";
import color from "@definitions/mui/color";
import Text from "@ds/components/Text";
import { PlayVideo } from "@icons/mobile";
import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import useStyles from "../partial-styles";

const VideoPartial: React.FC = () => {
  const { t } = useTranslation("common");
  const [textEllipsis, setTextEllipsis] = React.useState(false);
  const classes = useStyles({ size: "xl", textEllipsis });

  const toggleEllipsis = () => {
    setTextEllipsis(!textEllipsis);
  };

  return (
    <Section pt="16px" pb="24px">
      <Box
        mb="16px"
        width="100%"
        height="246px"
        borderRadius="16px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.svgSize}
        sx={{
          backgroundImage:
            "url(https://storage-assurance-dev.mytens.id/assets/mytenscustomer/img_banner_about.jpg)",
          backgroundSize: "cover",
        }}
      >
        <PlayVideo />
      </Box>
      <Box className={classes.videoDescription}>
        <Box component="p">{t("about.desc1")}</Box>
        <Box component="p">{t("about.desc2")}</Box>
      </Box>
      <Text sx={{ color: color.primary.main, cursor: "pointer" }} onClick={toggleEllipsis}>
        {textEllipsis ? t("about.hide") : t("about.more")}
      </Text>
    </Section>
  );
};

export default VideoPartial;
